import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./_index.scss";
import AuthLayout from "../AuthLayout";
import { StyledLockIcon } from "../../../utils/icons";
import CommonButton from "../../../Components/Button";
import { Color_Styling } from "../../../utils/constants";
import { useUpdatePasswordMutation } from "../../../features/Authentication/loginSlice";
import { matchPasswords, nameValidation, passwordValidation } from "../../../utils/validations";
import { useToast } from "../../ToastProvider";
import InputError from "../../../Components/InputError";

const Index = () => {
  const navigate = useNavigate();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [updatePassword, { isLoading, isError, isSuccess, data }] = useUpdatePasswordMutation();
  const [isMobile, setIsMobile] = useState(false);
  const { showSuccess, showError } = useToast();
  const [validation,setValidation] = useState({
    temporary:"",
    new:"",
    confirm:""
  })

  useEffect(() => {
    const checkMobileView = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    checkMobileView();
    window.addEventListener("resize", checkMobileView);
    return () => window.removeEventListener("resize", checkMobileView);
  }, []);

  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });
  const [temp, setTemp] = useState({
    tempPassword: "",
    showPassword: false,
  });

  const handleSetPassword = async(e) => {
    e.preventDefault();
    
    const temporaryValidation = nameValidation(temp.tempPassword,"Temporary Password")
    const newValidation = passwordValidation(values.password)
    const confirmValidation = matchPasswords(values.password,confirmPassword)
    if(temporaryValidation.isValid && newValidation.isValid && confirmValidation.isValid){
      setValidation({
        temporary:"",
        new:"",
        confirm:""
      })
      try{
        const payload = {
          tempPassword:temp.tempPassword,
          newPassword:values.password,
          confirmPassword:confirmPassword
        }
        const result = await updatePassword(payload).unwrap()
        console.log(result,"success")
        showSuccess({
          body:"Password updated successfully"
        })
        navigate("/successful")
      }catch(err){
        showError({
          body: err?.data?.message || err?.status   || "something went wrong"
        });
      }
    }
    else{
      setValidation({
        temporary:temporaryValidation.message,
        new:newValidation.message,
        confirm:confirmValidation.message
      })
    }
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleClickTempPassword = () => {
    setTemp({
      ...temp,
      showPassword: !temp.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handlePasswordChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
    });
  };
  const handleTempPasswordChange = (prop) => (event) => {
    setTemp({
      ...temp,
      [prop]: event.target.value,
    });
  };

  return (
    <AuthLayout>
      <div className='contentContainerUpdatePass'>
        <div className='welcome_wrapper_update_pass'>
          <div className='heading_text_update_pass'>Create New Password</div>
          <div className='welcome_text_update_pass'>Hey, your password must be different from any of your previous passwords.</div>
        </div>
        <form>
          <div className='password_fields_wrapper'>
            <div className='value_fields_name_update01'>
              <label htmlFor='temp_password'>Temporary Password</label>
            </div>
            <div className='value_fields'>
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  type={temp.showPassword ? "text" : "password"}
                  onChange={handleTempPasswordChange("tempPassword")}
                  value={temp.tempPassword}
                  className={`form_control_update_pass ${validation.temporary.length ? "error" : ""}`}
                  id='temp_password'
                  placeholder={isMobile ? "New Password" : "|  Enter Temporary Password"}
                  style={{
                    paddingLeft: temp.tempPassword ? "0.521vw" : "1.667vw",
                    width: "100%",
                    boxSizing: "border-box",
                    color: temp.tempPassword ? "#000000" : "#B3B3B3",
                  }}
                />
                {temp.tempPassword.length > 0 && (
                  <div className='show_button' onClick={handleClickTempPassword} onMouseDown={handleMouseDownPassword}>
                    {temp.showPassword ? "Hide" : "Show"}
                  </div>
                )}
                <StyledLockIcon passwordVisible={temp.tempPassword} />
              </div>
              {validation.temporary.length ? <InputError text={validation.temporary}/> : <div></div>}
            </div>
            <div className='value_fields_name_update02'>
              <label htmlFor='new_password'>New Password</label>
            </div>
            <div className='value_fields'>
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  type={values.showPassword ? "text" : "password"}
                  onChange={handlePasswordChange("password")}
                  value={values.password}
                  className={`form_control_update_pass ${validation.new.length ? "error" : ""}`}
                  id='new_password'
                  placeholder={isMobile ? "New Password" : "|  Enter Password"}
                  style={{
                    paddingLeft: values.password ? "0.521vw" : "1.667vw",
                    width: "100%",
                    boxSizing: "border-box",
                    color: values.password ? "#000000" : "#B3B3B3",
                  }}
                />
                {values.password.length > 0 && (
                  <div className='show_button' onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                    {values.showPassword ? "Hide" : "Show"}
                  </div>
                )}
                <StyledLockIcon passwordVisible={values.password} />
              </div>
              {validation.new.length ? <InputError text={validation.new}/> : <div></div>}
            </div>
            <div className='value_fields_name_update02'>
              <label htmlFor='confirm_password'>Confirm Password</label>
            </div>
            <div className='value_fields'>
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  value={confirmPassword}
                  type='text'
                  className={`form_control_update_pass ${validation.confirm.length ? "error" : ""}`}
                  id='new_password'
                  placeholder={isMobile ? "Confirm Password" : "|  Re-Enter Password"}
                  style={{
                    paddingLeft: confirmPassword ? "0.521vw" : "1.667vw",
                    width: "100%",
                    boxSizing: "border-box",
                    color: confirmPassword ? "#000000" : "#B3B3B3",
                  }}
                />
                <StyledLockIcon passwordVisible={confirmPassword} />
              </div>
              {validation.confirm.length ? <InputError text={validation.confirm}/> : <div></div>}
            </div>
          </div>
          <div className='forgot_pass_update_pass'>
            {/* <button
              type='submit'
              className='reset_pass_update_pass'
              onClick={handleSetPassword} // Function to handle form submission
            >
              Reset Password
            </button> */}
            <CommonButton
              text={"Reset Password"}
              color={Color_Styling.basic}
              customTextColor={Color_Styling.white}
              fullWidth
              inputProps={{ style: { padding: "0.833vw 0.521vw" } }}
              onClick={handleSetPassword}
              isLoading={isLoading}
              sx={{padding: "0.833vw 0.521vw"}}
            />
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default Index;
